import { Minus, Plus } from 'phosphor-react';
import React from 'react';

const QuantityInput = ({ onQuantityChange, quantity }) => {
  const increase = () => {
    onQuantityChange(quantity + 1);
  };
  const decrease = () => {
    onQuantityChange(quantity - 1);
  };

  return (
    <div className="cart-container__item-quantity-input">
      <Minus size="12" color="#737373" onClick={decrease} />
      <span className="cart-container__item-quantity-input-value no-select">
        {quantity}
      </span>
      <Plus size="12" color="#737373" onClick={increase} />
    </div>
  );
};

export default QuantityInput;
